import { render, staticRenderFns } from "./SliceImageAccentSquare.vue?vue&type=template&id=7f1a3b90&lang=pug&"
import script from "./SliceImageAccentSquare.vue?vue&type=script&lang=js&"
export * from "./SliceImageAccentSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports